module.exports = __webpack_public_path__ + "img/panda-bubble.b41c0ad2.svg";